export class MessageMaintenance {
    id: number;
    message: string;

    constructor(
        id: number,
        message: string,
    ) {
        this.id = id;
        this.message = message;
    }

    static factory(message: MessageMaintenanceAPI): MessageMaintenance {
        return new MessageMaintenance(
            message.id,
            message.message,
        );
    }
}

export type MessageMaintenanceAPI = {
    id: number;
    message: string;
}


